import React, { useEffect, useState } from 'react';
import axios from '../../api/axios';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../styles/loginPage.css';
import { notify } from '../toast';
import { jwtDecode } from 'jwt-decode';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [tempPassword, setTempPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = sessionStorage.getItem('accessToken');

    if (accessToken) {
      const decoded = jwtDecode(accessToken);

      const exp = decoded?.exp;
      if (Date.now() <= exp * 1000) {

        // @ts-ignore
        setEmail(decoded?.userInfo.email || "");
      }
    } else {
      setEmail(state?.email);
    }
  }, [state]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email.length === 0) {
      notify('warning', 'reset through forgot password');
      navigate('/');
    }
    setError('');

    try {
      setLoading(true);
      const response = await axios.put('/resetPassword', { email, tempPassword, newPassword });
      const res = response?.data;
      notify('success', res?.success);

      const accessToken = sessionStorage.getItem('accessToken');
      if (!accessToken) {
        const response = await axios.post('/login', { email, password: newPassword });
        const accessToken = response?.data?.token;
        sessionStorage.setItem('accessToken', accessToken);
        notify('success', response?.data?.success);
      }

      navigate('/');

    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || 'error fetching server information';
      setError(errorMessage);
    } finally {
      setLoading(false);
      setTempPassword('');
      setNewPassword('');
    }
  };

  return (
    <div className="body-login">
      <div className='login-container'>
        {error && <div style={{ color: 'red', marginBottom: '15px', textAlign: 'center' }}>{error}</div>}
        <h2>Reset Password</h2>
        <form onSubmit={handleSubmit}>

          <div>
            <label>Temporary Password</label>
            <input
              type="password"
              value={tempPassword}
              onChange={(e) => setTempPassword(e.target.value)}
              required
            />
          </div>

          <div>
            <label>New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit">
            {loading ? <span className="spinner" /> : 'Submit'}
          </button>

        </form>

      </div>
    </div>
  );
};

export default ResetPassword;
